import { AppServices } from '../services/app.services';
import { AppStoreFacade } from '../facades/app-store.facade';
import Vue from 'vue';

export class AppModule extends Vue {

  Store = new AppStoreFacade();
  Services = AppServices;

}